var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4443 9.04606C28.2116 8.50516 30.5441 8.76845 31.7588 9.40153L31.1768 11.9328C28.1908 10.0846 25.4581 12.3133 27.5078 13.2502C29.5574 14.187 30.4429 14.9723 30.873 15.5041C31.3004 16.0325 32.1948 18.3358 29.127 20.34C26.7458 21.8955 23.6782 21.0826 22.5225 20.6183L23.1299 18.1877C23.8217 18.4746 25.4864 18.92 26.6729 18.6691C28.1668 18.3531 29.2482 17.4596 25.9639 15.757C22.6795 14.0544 23.7873 11.2756 24.167 10.7433C24.5466 10.2116 25.5569 9.31776 26.4443 9.04606ZM13.2168 20.9738H9.80078L7.19336 11.4025C10.0679 12.8409 11.4285 16.0363 11.749 17.4543L14.6338 9.09782H17.9746L13.2168 20.9738ZM42.1602 20.923H39.2754L38.9463 19.3019H34.998L34.3652 20.923H31.1768L36.3896 8.97086H39.6543L42.1602 20.923ZM20.5225 20.8468H17.4355L19.2578 8.99625H22.4463L20.5225 20.8468ZM35.959 16.922H38.4648L37.5537 12.5412L35.959 16.922Z",
    fill: "#00229B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.312 15.3523C10.3504 13.0733 7.76913 10.2373 3.84668 9.14844H8.42709C9.26219 9.14844 10.072 9.37633 10.3504 10.6677C10.5731 11.7009 11.0842 14.1453 11.312 15.3523Z",
    fill: "#F79A00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.1137,
    height: 29,
    rx: 4.5,
    stroke: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/VISA.8abd5f6dc9fccc6b9771629b9a28606b.svg";
export { ForwardRef as ReactComponent };